<script setup lang="ts">
interface Props {
  src: string
}

defineProps<Props>()
</script>

<template>
  <div class="flex w-18 items-center justify-around gap-x-1 px-1">
    <img :src />
    <span>
      <slot />
    </span>
  </div>
</template>
